import React, { useEffect, useState } from 'react'
import UserSearchInput from '../../../ProjectsWindow/components/ProjectAuthorization/components/UserSearchInput'
import DatePicker from '../../../../components/DatePicker/DatePicker'
import { VscClearAll } from 'react-icons/vsc'
import { useLanguage } from '../../../../LanguageProvider';
import DragAndDropFileUpload from '../../../../components/DragAndDropFileUpload/DragAndDropFileUpload';
import SHDocumentsCard from './components/SHDocumentsCard/SHDocumentsCard';
import './SocialHiveDocuments.css'
import { GrDocumentText } from 'react-icons/gr';
import { PiFileImage, PiFileVideo } from 'react-icons/pi';
import { TbFileCode } from 'react-icons/tb';
import { HiOutlineDocumentDuplicate } from 'react-icons/hi';
import SHDocumentTable from './components/SHDocumentTable/SHDocumentTable';

export default function SocialHiveDocuments() {
    const { getTranslation } = useLanguage();
    const [filteredDocuments, setFilteredDocuments] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const docs = [
        { name: 'Word belgesi', description: 'Belge ile ilgili detay açıklaması', uploadDate: '30.01.2024 10:30', extension: 'doc' },
        { name: 'Pdf Dosyası', description: 'Belge ile ilgili detay açıklaması', uploadDate: '30.01.2024 10:30', extension: 'pdf' },
        { name: 'Excel Belgesi', description: 'Belge ile ilgili detay açıklaması', uploadDate: '30.01.2024 10:30', extension: 'csv' },
        // …
    ];
    // Filtreleme fonksiyonu
    const filterDocuments = () => {
        console.log("filtered")
    };

    // Dependencies değiştiğinde filtreyi uygula
    useEffect(() => {
        filterDocuments();
    }, [searchQuery, startDate, endDate]);

    const handleSearch = (value) => {
        setSearchQuery(value);
    };

    const handleStartDateChange = (value) => setStartDate(value);
    const handleEndDateChange = (value) => setEndDate(value);

    const handleClear = () => {
        setSearchQuery("");
        setStartDate(null);
        setEndDate(null);
    };
    return (
        <div className='social-hive-pages-main' style={{ paddingTop: 0 }}>

            <div
                style={{
                    flexDirection: 'row',
                    display: 'flex',
                    top: 0,
                    backgroundColor: 'inherit',
                    zIndex: 99,
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    gap: '15px',
                }}
            >
                <span style={{ color: 'var(--collection-title-color)' }}>
                    {getTranslation("comingSoon")}
                </span>
            </div>

            {/* <div
                style={{
                    flexDirection: 'row',
                    display: 'flex',
                    position: 'sticky',
                    top: 0,
                    backgroundColor: 'inherit',
                    zIndex: 99,
                    marginLeft: '-2px',
                    marginBottom: '2px',
                    alignItems: 'center',
                    gap: '15px',
                }}
            >
                <UserSearchInput
                    style={{ marginBottom: '21px', height: '15px' }}
                    placeholder={getTranslation("search")}
                    onSearch={handleSearch}
                    value={searchQuery}
                />
                <DatePicker
                    key={`startDate-${startDate?.toISOString() || 'none'}`}
                    buttonStyle={{ width: "132px", height: '38px' }}
                    initialDate={startDate}
                    onDateSelect={handleStartDateChange}
                    toggleLabel={getTranslation("startDate")}
                />
                <DatePicker
                    key={`endDate-${endDate?.toISOString() || 'none'}`}
                    buttonStyle={{ width: "132px", height: '38px' }}
                    initialDate={endDate}
                    onDateSelect={handleEndDateChange}
                    toggleLabel={getTranslation("endDate")}
                />

                <span
                    style={{
                        color: 'var(--sh-chat-message-font-color)',
                        cursor: 'var(--pointer)',
                    }}
                    onClick={handleClear}
                >
                    <VscClearAll size={23} />
                </span>
            </div>

            <DragAndDropFileUpload />
            <div className='social-hive-documents-card-holder'>
                <SHDocumentsCard icon={<GrDocumentText size={24} color='rgba(98, 123, 190, 1)' />} count={"102"} type={"Documents"} />
                <SHDocumentsCard icon={<PiFileImage size={24} color='rgba(164, 92, 93, 1)' />} count={"1.5k"} type={"Image"} />
                <SHDocumentsCard icon={<TbFileCode size={24} color='rgba(101, 89, 230, 1)' />} count={"5"} type={"Code"} />
                <SHDocumentsCard icon={<PiFileVideo size={24} color='rgba(78, 101, 216, 1)' />} count={"5"} type={"Video"} />
                <SHDocumentsCard icon={<HiOutlineDocumentDuplicate size={24} color='rgba(87, 139, 132, 1)' />} count={"5"} type={"Projects"} />
            </div>

            <SHDocumentTable documents={docs} /> */}
        </div>
    )
}
